import { useQuery } from '@tanstack/react-query';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@nesso/ui/primitives/dropdown-menu';

import { adminUserOptions } from '@/entities/admin-user';
import { SignOutMenuItem } from '@/features/identity/sign-out';

import { AdminUserDropdownAvatar } from './user-dropdown/admin-user-dropdown-avatar';
import { AdminUserDropdownInfo } from './user-dropdown/admin-user-dropdown-info';

export function UserDropdown() {
    const { data: user } = useQuery(adminUserOptions());

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    aria-label="Account menu"
                    className="focus-visible:ring-ring rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
                >
                    <AdminUserDropdownAvatar email={user?.email} />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" sideOffset={5} className="min-w-56">
                {user?.email && <AdminUserDropdownInfo email={user.email} />}
                <DropdownMenuSeparator />
                <SignOutMenuItem />
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
